import React, { useState } from "react";
import axios from "axios";
import { Tag, Loader2, X, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CouponInput({ amount, bookingType, email, applied, onApplied, idPrefix = "coupon" }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const apply = async () => {
    if (!code.trim()) return;
    setBusy(true); setError("");
    try {
      const res = await axios.post(`${API}/coupons/validate`, { code: code.trim().toUpperCase(), amount, booking_type: bookingType, patient_email: email || null }, { withCredentials: true });
      if (res.data.valid) onApplied({ code: res.data.code, discount: res.data.discount, final: res.data.final_amount, message: res.data.message });
      else setError(res.data.message || "Invalid coupon");
    } catch (e) {
      setError(e.response?.data?.detail || "Could not validate coupon");
    } finally { setBusy(false); }
  };

  if (applied) {
    return (
      <div data-testid={`${idPrefix}-applied`} className="flex items-center justify-between p-2.5 bg-emerald-50 border border-emerald-200 rounded-xl text-xs">
        <span className="flex items-center gap-1.5 text-emerald-900"><CheckCircle2 className="w-4 h-4 text-emerald-600" /><b className="font-mono">{applied.code}</b> · −₹{applied.discount}</span>
        <button type="button" onClick={() => { onApplied(null); setCode(""); }} data-testid={`${idPrefix}-remove`} className="text-emerald-700 hover:text-rose-600"><X className="w-3.5 h-3.5" /></button>
      </div>
    );
  }
  return (
    <div className="space-y-1">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Tag className="w-3.5 h-3.5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="Promo code (e.g. WELCOME10)" data-testid={`${idPrefix}-input`} className="w-full pl-8 pr-3 py-2 bg-[#FBF9F4] border border-gray-200 rounded-xl text-xs font-mono uppercase" />
        </div>
        <button type="button" onClick={apply} disabled={busy || !code} data-testid={`${idPrefix}-apply-btn`} className="px-3 py-2 bg-[#0D3B2E] disabled:opacity-40 text-white text-xs font-semibold rounded-xl">{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "Apply"}</button>
      </div>
      {error && <p data-testid={`${idPrefix}-error`} className="text-[11px] text-rose-700 font-semibold">{error}</p>}
    </div>
  );
}
